import React from 'react';

import type {IAuthState, IUser} from 'types';

export interface IUserContext {
  userId: string;
  userEmail: string;
  userName?: string;
  userPhone?: string;
  accessLevel: string;
  termsOfServiceUrl?: string;
  termsOfServiceAcceptedAt?: string;
  setCurrentUser(user: IUser): void;
  onSignOut(state?: IAuthState): void;
  storeId?: string;
  identityId?: string | null;
}

export const UserContext = React.createContext<IUserContext>({
  userId: '',
  userEmail: '',
  userName: '',
  accessLevel: '',
  setCurrentUser: () => {},
  onSignOut: () => {}
});
